// extracted by mini-css-extract-plugin
export default {"buttonContainer":"Teams_buttonContainer__e8Fze","teamName":"Teams_teamName__0KXZV"};